import { createAction, props } from '@ngrx/store';

import {
  IProduct,
  IProductPagination,
  EProductActions,
} from '../models/product.model';

export const loadProducts = createAction(
  EProductActions.LOAD_PRODUCTS,
  props<{ pagination: IProductPagination; activePagination? }>()
);

export const loadProductsSuccess = createAction(
  EProductActions.LOAD_PRODUCTS_SUCCESS,
  props<{
    products: IProduct[];
    pagination: IProductPagination;
  }>()
);

export const loadProductsError = createAction(
  EProductActions.LOAD_PRODUCTS_ERROR,
  props<{ error: any }>()
);

export const refreshProducts = createAction(
  EProductActions.REFRESH_PRODUCTS,
  props<{ pagination: IProductPagination }>()
);

export const createProducts = createAction(
  EProductActions.CREATE_PRODUCTS,
  props<{ product: IProduct }>()
);

export const createProductsSuccess = createAction(
  EProductActions.CREATE_PRODUCTS_SUCCESS
);

export const createProductsError = createAction(
  EProductActions.CREATE_PRODUCTS_ERROR,
  props<{ error: any }>()
);

export const updateProducts = createAction(
  EProductActions.UPDATE_PRODUCTS,
  props<{ product: IProduct }>()
);

export const updateProductsSuccess = createAction(
  EProductActions.UPDATE_PRODUCTS_SUCCESS
);

export const updateProductsError = createAction(
  EProductActions.UPDATE_PRODUCTS_ERROR,
  props<{ error: any }>()
);

export const deleteProducts = createAction(
  EProductActions.DELETE_PRODUCTS,
  props<{ product: IProduct }>()
);

export const deleteProductsSuccess = createAction(
  EProductActions.DELETE_PRODUCTS_SUCCESS
);

export const deleteProductsError = createAction(
  EProductActions.DELETE_PRODUCTS_ERROR,
  props<{ error: any }>()
);
